import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authApi from "../api/authApi";

// Thunks
export const loginUser = createAsyncThunk("auth/loginUser", async (credentials, thunkAPI) => {
  try {
    const res = await authApi.login(credentials);

    // Save token
    localStorage.setItem("token", res.data?.data?.access_token);

    return res.data;
  } catch (errObj) {
    console.log('err', errObj);
    return thunkAPI.rejectWithValue(errObj.response?.data?.message || "Login failed");
  }
});

export const logoutUser = createAsyncThunk("auth/logoutUser", async (_, thunkAPI) => {
  try {
    state.Auth.token = null;
    await authApi.logout();
  } catch (errObj) {
    console.log('logout error', errObj);
  }

  localStorage.removeItem("token");
  return true;
});

const authSlice = createSlice({
  name: "auth",
  initialState: {
    authData: null,
    token: null,
    loading: false,
    error: null,
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      // login
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading  = false;
        state.authData = action.payload?.data;
        state.token    = action.payload?.data?.access_token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // logout
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.token = null;
      });
  },
});

export default authSlice.reducer;
